<template>
  <div class="credits_top"></div>

  <div id="credits" class="section">



    <div class="credits_wrap">

      <div class="credits_text">

        <div class="credits_title"><h1>Credits</h1></div>

        <p>キャスト</p>
        <p class="main_cast">小林エレキ&nbsp;&nbsp;&nbsp;白波多カミン</p>

        <p class="credits_cast">米澤成美&nbsp;&nbsp;&nbsp;&nbsp;
            石本日悠&nbsp;&nbsp;&nbsp;&nbsp;
            瀧澤綾音&nbsp;&nbsp;&nbsp;&nbsp;<br class="norm_br_a">
            土田拓生&nbsp;&nbsp;&nbsp;&nbsp;
            藤一平
        </p>

        <p class="credits_staff">
        <span class="no_wrap"><span class="staff_title">●プロデューサー：</span><span id="adjust_font">ヨシダシゲル・<span class="tsuchiyoshi">𠮷</span>野雄大</span>&nbsp;</span><br class="norm_br_a">
        <span class="staff_title">●監督・編集：</span><span class="names">堀江実&nbsp;</span><br class="norm_br_a">
        <span class="staff_title">●脚本：</span><span class="names">ヤマザキアキラ</span><br class="norm_br_a"><br class="norm_br_b">
        <span class="staff_title">●撮影：</span><span class="names">ヨシダシゲル・堀江実&nbsp;</span><br class="norm_br_a">
        <span class="staff_title">●撮影助手：</span><span class="names">髙木美佑&nbsp;</span><br class="norm_br_a">
        <span class="staff_title">●音楽：</span><span class="names">白波多カミン・テンテンコ</span><br class="norm_br_a"><br class="norm_br_b">
        <span class="staff_title">●録音：</span><span class="names">横川一&nbsp;</span><br class="norm_br_a">
        <span class="staff_title">●整音：</span><span class="names">川本七平&nbsp;</span><br class="norm_br_a">
        <span class="staff_title">●助監督：</span><span class="names">東響生&nbsp;</span><br class="norm_br_a"><br class="norm_br_b">
        <span class="staff_title">●スチール：</span><span class="names">髙木美佑&nbsp;</span><br class="norm_br_a">
        <span class="staff_title">●タイトル：</span><span class="names">阿部つよし</span><br class="norm_br_a"><br class="norm_br_b">
        <span class="staff_title">●制作協力：</span><span class="names">橋野純平・藤村英恵&nbsp;</span><br class="norm_br_a">
        <span class="staff_title">●衣装協力：</span><span class="names">堀江進司</span><br class="norm_br_a"><br class="norm_br_b">
        <span class="staff_title">●撮影協力：</span>宮崎幸司・甲斐聖太郎・<br class="norm_br_a">山本泉一・岩本慎史・秋津ねを<br class="norm_br_a"><br class="norm_br_b">
        <span class="staff_title">●機材協力：</span><span class="names">中野貴大・川本七平&nbsp;</span><br class="norm_br_a">
        <span class="staff_title">●ロケーション協力：</span><span class="names">コクテイル書房・<br class="norm_br_c">藤岡啓二</span><br class="norm_br_a">
        <span class="no_wrap"><span class="staff_title">●音楽録音・編曲協力：</span>大谷能生・<br class="norm_br_c">猪爪東風(ayU tokiO)</span><br class="norm_br_a"><br class="norm_br_b">
        <span class="staff_title">●レコーディングスタジオ：</span><span class="no_wrap" id="adjust_font">日野音楽室第Ⅲ</span><br class="norm_br_a"><br class="norm_br_b">
        <span class="staff_title">●協力プロダクション：</span><span class="no_wrap" id="adjust_font">コギトワークス・<br class="norm_br_a">モノサシパブリックリレーションズ</span><br class="norm_br_a"><br class="norm_br_b">
        <span class="staff_title">●企画・制作：</span><br class="norm_br_c">プラネットナインピクチャーズ<br class="norm_br_a"><br class="norm_br_b">
        </p>
        
        <p id="filminfo">
          <span class="no_wrap">2023年/4K+8mm/カラー/<br class="norm_br_c">スタンダード/ステレオ/65分</span>
        </p>

        <div class="aff2">
          
            <svg width="58" height="24" viewBox="0 0 58 24" xml:space="preserve">
            <g transform="matrix(0.6852768274 0 0 0.6852768274 29 12)" id="qxAQGo2P6ESoDudyGXlX6"  >
            <g style=""   >
            <g transform="matrix(1 0 0 1 0 0)" id="eeqHDMb5pNPCIyjuIoCH5"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  transform=" translate(-204.297, -204.297)" d="M 0 408.594 L 0 0 L 408.594 0 L 408.594 408.594 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -0.6805 -2.125)" id="U4B7pCUja4Wn0CRWYbaYy"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-203.6165, -202.172)" d="M 207.223 202.167 L 200.01000000000002 198.008 L 200.01000000000002 206.336 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 18.2075 -2.125)" id="QxJva4l434BJ79EIL3BA2"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-222.5045, -202.172)" d="M 226.113 202.167 L 218.896 198.008 L 218.896 206.336 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -28.092 -3.3915)" id="b1a1HA_5s1AKi1eFdd8kc"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-176.205, -200.9055)" d="M 168.839 213.109 L 176.2 196.5 L 183.56799999999998 213.109 L 189.505 213.109 L 178.685 188.702 L 173.724 188.702 L 162.905 213.109 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -4.8995 -3.4085)" id="Q5yS06np2or-ImeWJ9rJr"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-199.3975, -200.8885)" d="M 196.988 213.109 L 191.572 213.109 L 191.572 191.381 L 194.274 188.668 L 207.223 188.668 L 207.223 194.09 L 196.988 194.09 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 13.9825 -3.4085)" id="ofHILKguu0bnXOLI12DJx"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-218.2795, -200.8885)" d="M 215.874 213.109 L 210.446 213.109 L 210.446 191.381 L 213.159 188.668 L 226.113 188.668 L 226.113 194.09 L 215.874 194.09 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -28.179 5.0449997442)" id="NRldIv97IUTBF9ujEBEnj"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-176.118, -209.3419997442)" d="M 179.397 209.342 C 179.397 211.14700000000002 177.928 212.621 176.119 212.621 C 174.304 212.621 172.839 211.14600000000002 172.839 209.342 C 172.839 207.52800000000002 174.304 206.06300000000002 176.119 206.06300000000002 C 177.928 206.062 179.397 207.527 179.397 209.342" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 32.26 -3.3235)" id="ZTDEeGZ-I6dBdFwTaNJcq"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-236.557, -200.9735)" d="M 242.109 205.6 L 242.132 205.57999999999998 C 243.113 204.57299999999998 243.808 203.784 244.54500000000002 202.838 C 246.22400000000002 200.697 246.29200000000003 198.088 246.29200000000003 197.781 C 246.29200000000003 192.78900000000002 242.23300000000003 188.72400000000002 237.23700000000002 188.72400000000002 C 232.25000000000003 188.72400000000002 228.18500000000003 192.788 228.18500000000003 197.781 L 233.55500000000004 197.781 C 233.55500000000004 195.74800000000002 235.21100000000004 194.09 237.23700000000002 194.09 C 239.27300000000002 194.09 240.92700000000002 195.748 240.92700000000002 197.766 C 240.92700000000002 197.772 240.86300000000003 198.834 240.323 199.536 C 239.809 200.182 239.27200000000002 200.821 238.304 201.809 L 226.822 213.22299999999998 L 234.441 213.22299999999998 L 245.916 213.22299999999998 L 245.916 208.41099999999997 L 239.283 208.41099999999997 L 242.109 205.6 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -38.885 14.292)" id="K-GZSSg0zGesiplXvA5vq"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-165.412, -218.589)" d="M 166.339 220.076 L 164.49099999999999 220.076 L 164.10999999999999 220.969 L 162.932 220.969 L 164.916 216.209 L 165.958 216.209 L 167.892 220.969 L 166.71 220.969 L 166.339 220.076 z M 166.036 219.229 L 165.429 217.627 L 164.82 219.229 L 166.036 219.229 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -33.6075 14.2925)" id="Kg-d3JFEqW4KlmS1BhDyR"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-170.6895, -218.5895)" d="M 170.49 216.209 C 171.118 216.209 171.51000000000002 216.412 171.745 216.625 C 171.951 216.818 172.17000000000002 217.154 172.17000000000002 217.686 C 172.17000000000002 217.983 172.103 218.362 171.78500000000003 218.663 C 171.61900000000003 218.81900000000002 171.37500000000003 218.96200000000002 171.10100000000003 219.032 L 172.61300000000003 220.97 L 171.22700000000003 220.97 L 169.89800000000002 219.099 L 169.89800000000002 220.97 L 168.76600000000002 220.97 L 168.76600000000002 216.21 L 170.49 216.21 z M 169.899 218.379 L 170.163 218.379 C 170.36800000000002 218.379 170.64200000000002 218.346 170.836 218.166 C 170.919 218.096 171.024 217.936 171.024 217.703 C 171.024 217.439 170.892 217.291 170.792 217.217 C 170.611 217.084 170.31 217.06500000000003 170.168 217.06500000000003 L 169.899 217.06500000000003 L 169.899 218.379 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -29.7355 14.292)" id="9XBR9qSvtkOoEnYn2swXY"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-174.5615, -218.589)" d="M 175.133 217.137 L 175.133 220.969 L 173.99800000000002 220.969 L 173.99800000000002 217.137 L 172.925 217.137 L 172.925 216.209 L 176.198 216.209 L 176.198 217.137 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -25.9095 14.2895)" id="bh7LBbTQGTMVqrBnhH2Y-"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-178.3875, -218.5865)" d="M 179.441 217.373 C 179.075 217.06099999999998 178.763 217.023 178.623 217.023 C 178.46599999999998 217.023 178.271 217.06 178.136 217.203 C 178.071 217.264 178.017 217.373 178.017 217.5 C 178.017 217.604 178.053 217.693 178.127 217.76 C 178.24200000000002 217.864 178.41400000000002 217.91199999999998 178.751 218.033 L 179.112 218.166 C 179.331 218.246 179.594 218.346 179.78199999999998 218.529 C 180.07299999999998 218.795 180.148 219.14 180.148 219.414 C 180.148 219.90599999999998 179.968 220.332 179.709 220.59199999999998 C 179.27100000000002 221.035 178.641 221.07799999999997 178.317 221.07799999999997 C 177.966 221.07799999999997 177.656 221.03099999999998 177.344 220.87899999999996 C 177.09199999999998 220.76199999999997 176.81199999999998 220.54499999999996 176.62699999999998 220.35899999999995 L 177.213 219.56999999999996 C 177.344 219.69299999999996 177.539 219.86299999999997 177.671 219.94299999999996 C 177.85899999999998 220.05199999999996 178.057 220.10899999999995 178.285 220.10899999999995 C 178.434 220.10899999999995 178.639 220.07999999999996 178.811 219.94699999999995 C 178.892 219.87299999999993 178.976 219.73599999999993 178.976 219.55999999999995 C 178.976 219.40399999999994 178.914 219.28999999999994 178.811 219.21999999999994 C 178.684 219.11099999999993 178.37800000000001 219.00099999999995 178.241 218.95399999999995 L 177.82700000000003 218.81699999999995 C 177.60000000000002 218.74099999999996 177.34400000000002 218.63699999999994 177.14500000000004 218.43399999999994 C 176.88200000000003 218.16999999999993 176.85400000000004 217.83399999999995 176.85400000000004 217.60199999999995 C 176.85400000000004 217.19199999999995 176.98800000000003 216.83199999999994 177.27900000000005 216.53399999999993 C 177.62700000000007 216.18999999999994 178.03600000000006 216.09499999999994 178.49600000000007 216.09499999999994 C 178.82800000000006 216.09499999999994 179.37900000000008 216.16099999999994 179.94900000000007 216.57399999999996 L 179.441 217.373 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -20.2525 14.0325)" id="Ew6nKnJMz-amxcsWDoy5s"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-184.0445, -218.3295)" d="M 184.352 218.621 L 184.352 220.96900000000002 L 183.29 220.96900000000002 L 183.29 218.621 L 182.90099999999998 218.621 L 182.90099999999998 217.78300000000002 L 183.29 217.78300000000002 L 183.29 217.15400000000002 C 183.29 216.80400000000003 183.332 216.39200000000002 183.661 216.04900000000004 C 183.866 215.82600000000002 184.168 215.69000000000003 184.572 215.69000000000003 C 184.81300000000002 215.69000000000003 185.00900000000001 215.73300000000003 185.18 215.80300000000003 L 185.18 216.69800000000004 C 185.064 216.62600000000003 184.90800000000002 216.57500000000005 184.77700000000002 216.57500000000005 C 184.60700000000003 216.57500000000005 184.508 216.64900000000006 184.46200000000002 216.70200000000006 C 184.353 216.84800000000004 184.353 217.09800000000004 184.353 217.25500000000005 L 184.353 217.78400000000005 L 185.18800000000002 217.78400000000005 L 185.18800000000002 218.62200000000004 L 184.352 218.62200000000004 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -16.605 15.0765)" id="kousx-uYhiut5nTmjmryM"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-187.692, -219.3735)" d="M 189.127 220.568 C 188.83 220.851 188.335 221.078 187.68900000000002 221.078 C 187.04900000000004 221.078 186.54900000000004 220.851 186.26000000000002 220.568 C 185.925 220.246 185.758 219.787 185.758 219.38000000000002 C 185.758 218.96800000000002 185.925 218.51500000000001 186.26000000000002 218.20400000000004 C 186.549 217.91100000000003 187.049 217.66900000000004 187.68900000000002 217.66900000000004 C 188.335 217.66900000000004 188.83 217.91100000000003 189.127 218.20400000000004 C 189.459 218.51500000000004 189.626 218.96800000000005 189.626 219.38000000000002 C 189.626 219.787 189.459 220.246 189.127 220.568 M 187.093 218.775 C 186.939 218.937 186.85299999999998 219.13 186.85299999999998 219.38 C 186.85299999999998 219.66899999999998 186.968 219.862 187.093 219.972 C 187.22299999999998 220.109 187.415 220.208 187.69899999999998 220.208 C 187.938 220.208 188.12499999999997 220.132 188.27999999999997 219.972 C 188.44099999999997 219.835 188.53199999999998 219.64000000000001 188.53199999999998 219.38 C 188.53199999999998 219.13 188.44099999999997 218.93699999999998 188.27999999999997 218.775 C 188.12499999999997 218.625 187.93799999999996 218.548 187.68899999999996 218.548 C 187.447 218.549 187.247 218.625 187.093 218.775" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -12.4965 15.044)" id="y3f8fwDU5QUz2GKKK2fPe"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-191.8005, -219.341)" d="M 190.609 217.783 L 191.67100000000002 217.783 L 191.67100000000002 218.289 C 191.76300000000003 218.10899999999998 191.91000000000003 217.945 192.079 217.85 C 192.25400000000002 217.737 192.441 217.713 192.64700000000002 217.713 C 192.77700000000002 217.713 192.872 217.72299999999998 192.99200000000002 217.76 L 192.93800000000002 218.725 C 192.79500000000002 218.655 192.64300000000003 218.612 192.45200000000003 218.612 C 192.229 218.612 192.05900000000003 218.692 191.92700000000002 218.825 C 191.687 219.071 191.67100000000002 219.405 191.67100000000002 219.684 L 191.67100000000002 220.969 L 190.609 220.969 L 190.609 217.783 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -7.7945 14.5665)" id="NX5cw4Dig50jZ6Kl__EdW"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-196.5025, -218.8635)" d="M 196.89 218.621 L 196.89 220.96900000000002 L 195.82999999999998 220.96900000000002 L 195.82999999999998 218.621 L 195.462 218.621 L 195.462 217.78300000000002 L 195.82999999999998 217.78300000000002 L 195.82999999999998 216.758 L 196.89 216.758 L 196.89 217.78300000000002 L 197.54299999999998 217.78300000000002 L 197.54299999999998 218.621 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 -4.271 14.0705)" id="dc6eGkV9rQlltjykP7MPE"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-200.026, -218.3675)" d="M 198.352 215.766 L 199.415 215.766 L 199.415 218.166 C 199.54299999999998 218.016 199.68699999999998 217.906 199.81699999999998 217.83599999999998 C 200.03099999999998 217.72299999999998 200.218 217.70299999999997 200.45 217.70299999999997 C 200.706 217.70299999999997 201.094 217.73599999999996 201.38299999999998 218.02299999999997 C 201.67899999999997 218.31799999999996 201.701 218.70499999999996 201.701 218.95499999999996 L 201.701 220.96899999999997 L 200.642 220.96899999999997 L 200.642 219.34399999999997 C 200.642 219.11199999999997 200.635 218.86199999999997 200.463 218.70099999999996 C 200.368 218.61099999999996 200.207 218.55799999999996 200.05599999999998 218.55799999999996 C 199.825 218.55799999999996 199.694 218.66199999999998 199.63099999999997 218.71399999999997 C 199.41699999999997 218.91299999999998 199.41399999999996 219.21999999999997 199.41399999999996 219.37999999999997 L 199.41399999999996 220.96799999999996 L 198.35099999999997 220.96799999999996 L 198.35099999999997 215.766 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 0.0025 15.0765)" id="qsZTK5Hur5nKZxBPcJNqK"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-204.2995, -219.3735)" d="M 206.07 219.561 L 203.608 219.561 C 203.608 219.731 203.675 219.963 203.812 220.11 C 203.96800000000002 220.27 204.191 220.30300000000003 204.35000000000002 220.30300000000003 C 204.50900000000004 220.30300000000003 204.66400000000002 220.27000000000004 204.77800000000002 220.20900000000003 C 204.79800000000003 220.19300000000004 204.918 220.12300000000002 205.00900000000001 219.94700000000003 L 206.00900000000001 220.04300000000003 C 205.86700000000002 220.49600000000004 205.56900000000002 220.72900000000004 205.377 220.84600000000003 C 205.05700000000002 221.03200000000004 204.715 221.07800000000003 204.341 221.07800000000003 C 203.848 221.07800000000003 203.411 220.99800000000002 203.03300000000002 220.62300000000002 C 202.74400000000003 220.34600000000003 202.52900000000002 219.92000000000002 202.52900000000002 219.4 C 202.52900000000002 218.941 202.705 218.464 203.04000000000002 218.132 C 203.43500000000003 217.755 203.92100000000002 217.669 204.29600000000002 217.669 C 204.66000000000003 217.669 205.19400000000002 217.745 205.59600000000003 218.161 C 205.98900000000003 218.557 206.07000000000002 219.054 206.07000000000002 219.45 L 206.07000000000002 219.561 z M 205.084 218.951 C 205.07 218.914 205.025 218.715 204.87 218.572 C 204.75 218.465 204.584 218.394 204.36700000000002 218.394 C 204.09500000000003 218.394 203.93400000000003 218.505 203.83 218.601 C 203.744 218.691 203.675 218.804 203.64700000000002 218.951 L 205.084 218.951 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 5.6365 14.0325)" id="CGOupX5Kc3jgHvSuPhZcG"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-209.9335, -218.3295)" d="M 210.24 218.621 L 210.24 220.96900000000002 L 209.172 220.96900000000002 L 209.172 218.621 L 208.794 218.621 L 208.794 217.78300000000002 L 209.172 217.78300000000002 L 209.172 217.15400000000002 C 209.172 216.80400000000003 209.212 216.39200000000002 209.546 216.04900000000004 C 209.759 215.82600000000002 210.064 215.69000000000003 210.46599999999998 215.69000000000003 C 210.69899999999998 215.69000000000003 210.89399999999998 215.73300000000003 211.069 215.80300000000003 L 211.069 216.69800000000004 C 210.95999999999998 216.62600000000003 210.792 216.57500000000005 210.671 216.57500000000005 C 210.505 216.57500000000005 210.40099999999998 216.64900000000006 210.358 216.70200000000006 C 210.242 216.84800000000004 210.242 217.09800000000004 210.242 217.25500000000005 L 210.242 217.78400000000005 L 211.07299999999998 217.78400000000005 L 211.07299999999998 218.62200000000004 L 210.24 218.62200000000004 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 9.2065 15.1335)" id="LyyxSdUT16xB4YGVyyvt_"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-213.5035, -219.4305)" d="M 212.874 217.783 L 212.874 219.547 C 212.874 219.688 212.882 219.906 213.05599999999998 220.057 C 213.13 220.123 213.26 220.20899999999997 213.49399999999997 220.20899999999997 C 213.70499999999998 220.20899999999997 213.85599999999997 220.14699999999996 213.95399999999998 220.057 C 214.09799999999998 219.911 214.129 219.702 214.129 219.547 L 214.129 217.783 L 215.191 217.783 L 215.191 219.64999999999998 C 215.191 220.009 215.15 220.349 214.82 220.66599999999997 C 214.45 221.02499999999998 213.891 221.07799999999997 213.494 221.07799999999997 C 213.096 221.07799999999997 212.55 221.02499999999998 212.174 220.66599999999997 C 211.874 220.37899999999996 211.816 220.05699999999996 211.816 219.70699999999997 L 211.816 217.78299999999996 L 212.874 217.78299999999996 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 12.7405 14.5665)" id="ubPatv4qt8VwhzgtMKgcA"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-217.0375, -218.8635)" d="M 217.424 218.621 L 217.424 220.96900000000002 L 216.362 220.96900000000002 L 216.362 218.621 L 215.995 218.621 L 215.995 217.78300000000002 L 216.362 217.78300000000002 L 216.362 216.758 L 217.424 216.758 L 217.424 217.78300000000002 L 218.08 217.78300000000002 L 218.08 218.621 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 16.2475 15.1335)" id="o0g6LVKze5coLc2EyaC89"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-220.5445, -219.4305)" d="M 219.915 217.783 L 219.915 219.547 C 219.915 219.688 219.92999999999998 219.906 220.10299999999998 220.057 C 220.17899999999997 220.123 220.31099999999998 220.20899999999997 220.54399999999998 220.20899999999997 C 220.74399999999997 220.20899999999997 220.89499999999998 220.14699999999996 220.99699999999999 220.057 C 221.14899999999997 219.911 221.171 219.702 221.171 219.547 L 221.171 217.783 L 222.22799999999998 217.783 L 222.22799999999998 219.64999999999998 C 222.22799999999998 220.009 222.19799999999998 220.349 221.86599999999999 220.66599999999997 C 221.48899999999998 221.02499999999998 220.93699999999998 221.07799999999997 220.545 221.07799999999997 C 220.143 221.07799999999997 219.59099999999998 221.02499999999998 219.21499999999997 220.66599999999997 C 218.91499999999996 220.37899999999996 218.86099999999996 220.05699999999996 218.86099999999996 219.70699999999997 L 218.86099999999996 217.78299999999996 L 219.915 217.78299999999996 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 20.2745 15.044)" id="vgr5C5uA2nokQ4a2kVA5z"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-224.5715, -219.341)" d="M 223.381 217.783 L 224.44 217.783 L 224.44 218.289 C 224.539 218.10899999999998 224.679 217.945 224.855 217.85 C 225.03 217.737 225.21699999999998 217.713 225.417 217.713 C 225.551 217.713 225.65200000000002 217.72299999999998 225.762 217.76 L 225.714 218.725 C 225.571 218.655 225.405 218.612 225.231 218.612 C 225.00199999999998 218.612 224.835 218.692 224.696 218.825 C 224.465 219.071 224.44 219.405 224.44 219.684 L 224.44 220.969 L 223.381 220.969 L 223.381 217.783 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 23.7245 15.0765)" id="Fgg19vOq_4DfyPVAJYqUG"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-228.0215, -219.3735)" d="M 229.786 219.561 L 227.331 219.561 C 227.331 219.731 227.403 219.963 227.53199999999998 220.11 C 227.695 220.27 227.92 220.30300000000003 228.07699999999997 220.30300000000003 C 228.23099999999997 220.30300000000003 228.39499999999998 220.27000000000004 228.50499999999997 220.20900000000003 C 228.51799999999997 220.19300000000004 228.64299999999997 220.12300000000002 228.73699999999997 219.94700000000003 L 229.72799999999998 220.04300000000003 C 229.58399999999997 220.49600000000004 229.296 220.72900000000004 229.1 220.84600000000003 C 228.78199999999998 221.03200000000004 228.43099999999998 221.07800000000003 228.064 221.07800000000003 C 227.56799999999998 221.07800000000003 227.132 220.99800000000002 226.75199999999998 220.62300000000002 C 226.45999999999998 220.34600000000003 226.25699999999998 219.92000000000002 226.25699999999998 219.4 C 226.25699999999998 218.941 226.42499999999998 218.464 226.75999999999996 218.132 C 227.16299999999995 217.755 227.65099999999995 217.669 228.01999999999995 217.669 C 228.38199999999995 217.669 228.91599999999994 217.745 229.31999999999996 218.161 C 229.70999999999995 218.557 229.78599999999997 219.054 229.78599999999997 219.45 L 229.78599999999997 219.561 z M 228.806 218.951 C 228.80100000000002 218.914 228.745 218.715 228.595 218.572 C 228.477 218.465 228.304 218.394 228.095 218.394 C 227.823 218.394 227.661 218.505 227.558 218.601 C 227.47199999999998 218.691 227.404 218.804 227.373 218.951 L 228.806 218.951 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 27.0875 14.3515)" id="FAkLcmGSpIhsX0-YH8eXu"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-231.3845, -218.6485)" d="M 231.383 219.787 C 231.763 219.787 232.056 220.076 232.056 220.43 C 232.056 220.805 231.763 221.088 231.383 221.088 C 231.007 221.088 230.71300000000002 220.805 230.71300000000002 220.43 C 230.713 220.076 231.007 219.787 231.383 219.787 M 230.835 216.209 L 231.92000000000002 216.209 L 231.92000000000002 219.43800000000002 L 230.835 219.43800000000002 L 230.835 216.209 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 39.0975 14.1695)" id="CWUTonHZBtJHTgw211-YO"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-243.3945, -218.4665)" d="M 245.678 221.285 L 241.10999999999999 221.285 L 242.558 219.826 C 243.07 219.301 243.444 218.84699999999998 243.727 218.426 C 243.874 218.20499999999998 244.02700000000002 217.922 244.02700000000002 217.571 C 244.02700000000002 217.51 244.02700000000002 217.21699999999998 243.853 217.038 C 243.773 216.948 243.622 216.876 243.44 216.876 C 243.204 216.876 243.038 216.981 242.94299999999998 217.09900000000002 C 242.80999999999997 217.269 242.749 217.591 242.73899999999998 217.781 L 241.21299999999997 217.781 C 241.22499999999997 217.062 241.54599999999996 216.537 241.84699999999995 216.25 C 242.23499999999996 215.875 242.74899999999994 215.648 243.46199999999996 215.648 C 244.30499999999995 215.648 244.80699999999996 215.974 245.05799999999996 216.226 C 245.29199999999997 216.453 245.61699999999996 216.87199999999999 245.61699999999996 217.576 C 245.61699999999996 218.277 245.28099999999995 218.754 244.77399999999997 219.21699999999998 L 243.80899999999997 220.07799999999997 L 245.67899999999997 220.07799999999997 L 245.67899999999997 221.285 z" stroke-linecap="round" />
            </g>
            <g transform="matrix(1 0 0 1 33.141 14.3135)" id="dlwSp0Brll8kY7BvPxZEO"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(35,24,21); fill-rule: nonzero; opacity: 0.92;"  transform=" translate(-237.438, -218.6105)" d="M 239.94 218.611 L 234.936 215.72299999999998 L 234.936 221.498 z" stroke-linecap="round" />
            </g>
            </g>
            </g>
            </svg>
        </div>

        <br>
        <p id="filminfo">
          <span class="contact">CONTACT US: <br class="norm_br_a"><span class="p9p">プラネットナインピクチャーズ&nbsp;&nbsp;&nbsp;&nbsp;<a href="mailto:p9pfilm@gmail.com">p9pfilm@gmail.com</a></span></span>
        </p>
        <div class="sns">
          <a href="https://x.com/ibara_yoru?s=20">
          <svg width="20" height="21" viewBox="0 0 100 102.25" xml:space="preserve">
          <g transform="matrix(0.0833333333 0 0 0.0833333333 50 51.09875)" id="xv5OOTBs-yqTOS9cSgB4m"  >
          <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  transform=" translate(0, 0)" d="M 114.163 -93.901 L 560.89 -613.185 L 455.03 -613.185 L 67.137 -162.29799999999994 L -242.67200000000003 -613.185 L -600 -613.185 L -131.50799999999998 68.63600000000008 L -600 613.1850000000001 L -494.134 613.1850000000001 L -84.50900000000001 137.03300000000007 L 242.67199999999997 613.1850000000001 L 600 613.1850000000001 L 114.137 -93.90099999999995 z M -30.835 74.643 L -78.303 6.748999999999995 L -455.989 -533.4906 L -293.385 -533.4906 L 11.412000000000035 -97.5 L 58.88000000000004 -29.605999999999995 L 455.08000000000004 537.115 L 292.476 537.115 L -30.83499999999998 74.66899999999998 z" stroke-linecap="round" />
          </g>
          </svg>
        </a>
        </div>
      </div>
      <div class="titlelogo_wrap">
      <div class="titlelogo"></div>
      </div>
      
    </div> <!-- credits wrap -->

  </div>
</template>

<style>

.contact{
  font-family: 'Shippori Mincho', sans-serif;
  font-weight: bold;
  letter-spacing:normal;
  font-size: 14px;
  white-space:nowrap;
}

.aff2{
top:0;
left: 0;
/* border: 2px solid rgb(13, 0, 255); */
height: auto;
width: 100%;
padding-top: 16px;
}


.sns{
top:0;
left: 0;
/* border: 2px solid rgb(13, 0, 255); */
height: auto;
width: 100%;
padding-top: 14px;
}

.twitter{
  border: 2px solid rgb(13, 0, 255);
  top:0;
left: 0;
}

.p9p{
  font-size: 12px;

}
a{
  text-decoration: none;
  color: inherit;
}


.credits_top{
  /* border: 2px solid rgb(13, 0, 255); */
  position: relative;
  background-image: url('../assets/Credits.jpg');
  background-size:cover;  /* 画像をdivにフィットさせる */
  background-repeat: no-repeat;  /* 画像の繰り返しを防ぐ */
  background-position: center;  /* 画像をdivの中央に配置する */
  height: auto;
  padding-bottom: 28%;
  width: auto;
}


#credits{
  /* border: 1px solid rgb(1, 60, 10);  */
  padding-top: 5vh;
  width:auto;
  height: auto;
  margin-bottom: 0;
  padding-bottom: 10vh;

  
}

.credits_wrap{
  /* border: 4px dashed rgb(60, 1, 1);  */
  display: flex;
  padding-top: 10vh;
  padding-left: 0vw;
  padding-bottom: 0vh;
  width:auto;
  height: auto;
  justify-content: center;
}


.titlelogo_wrap{
  /* border: 1px solid rgb(236, 24, 95);  */
  height: 50vh;
  width: auto;
  display: flex;

}

.titlelogo{
  /* border: 2px solid rgb(1, 111, 255);  */
  
  width:60px;
  height:auto;
  min-height: 350px;
  background-image: url('../assets/TITLE.svg');
  background-size:contain; 
  
  background-repeat: no-repeat;
  
  padding-top: 0;
  padding-bottom: 0;
}

.credits_text{
  /* border: 2px dashed rgb(144, 56, 2);  */
  text-align: right; 
  width: 90vw;
  max-width: 820px;
  height: auto;
  text-align:left;
  white-space: nowrap;
  padding-bottom: 5vh;
  letter-spacing: 1.1px;
}

.credits_text p{
  /* border: 1px solid rgb(253, 4, 4);  */
  font-family: 'Zen Kaku Gothic New', sans-serif;
  font-size: 14px;
  padding-bottom: 0vh;
  padding-left: 0px;
  padding-top: 6px;
  line-height: 16px;
  margin: 0; 
}

.credits_text p.main_cast{
 font-family: 'Zen Kaku Gothic New', sans-serif;
 font-size: 16px;
 line-height: 1.6rem;
}

.credits_text p.credits_cast{
 font-family: 'Zen Kaku Gothic New', sans-serif;
 font-size: 12px;
 line-height: 1.6rem;
}


.credits_text p.credits_staff{
 font-family: 'Zen Kaku Gothic New', sans-serif;
 font-size: 12px;
 line-height: 2em;
}

.credits_title{
  /* border: 2px solid rgb(251, 0, 255); */
  width: auto;
  height:auto;
  padding-left: 0;
  padding-top: 0;
  padding-bottom: 2vh;
  margin-top: 0;
  margin-top: 0;
  font-family: 'Zen Kaku Gothic New', sans-serif;
}

.credits_title h1{
  font-family: 'Shippori Mincho', sans-serif;
  font-size:32px;

  padding-left: 0;
  padding-top: 0;
  margin-top: 0;
  margin-top: 0;
}


#filminfo {
  font-size: 12px;
}
.names {
  font-size: 12px;  
}
.norm_br_a{
  display: block;
}
.norm_br_b{
  display: block;
}
.no_wrap{
  white-space:nowrap;
}

.staff_title{
  font-size:8px;
}

.tsuchiyoshi{
  font-weight: bold;
}

@media screen and (min-width:200px) {  
  .norm_br_a{
    display: block;
  }
  .norm_br_b{
    display: none;
  }
  .norm_br_c{
    display: none;
  }
  .norm_br_d{
    display: none;
  }

  .credits_text{
    /* border: 3px solid rgb(255, 65, 1);  */
    max-width: 264px;
    white-space:normal;
  }
  .titlelogo{
    /* border: 2px solid rgb(14, 255, 1);  */
    width: 30px;
  }

  #adjust_font {
  font-size: 10px;  
  }
  #filminfo {
  font-size: 10px;
  }

  #adjust_font2 {
  font-size: 9px;  
  }


}


@media screen and (min-width:390px) { 
  
  .credits_text{
    /* border: 2px dashed rgb(175, 255, 1);  */
    max-width: 270px;
    white-space:normal;
  }
  
  .norm_br_a{
    display: block;
  }
  .norm_br_b{
    display: none;
  }
  .norm_br_c{
    display: none;
  }
  .norm_br_d{
    display: none;
  }

  .no_wrap{
    white-space:nowrap;
  }

  #adjust_font {
  font-size: 12px;  
}

#adjust_font2 {
  font-size: 12px;  
  }

#filminfo {
  font-size: 12px;
  }





}

@media screen and (min-width:540px) {
    /*for iPad */
  .norm_br_a{
    display:none;
  }
  .norm_br_b{
    display: block;
  }

  .norm_br_c{
    display: none;
  }
  .norm_br_d{
    display: none;
  }


.titlelogo{
  /* border: 2px solid rgb(255, 1, 179);  */

  width:50px;
  margin-left: 6vh;
}


.credits_text{
  /* border: 3px solid rgb(87, 2, 144);  */
  
  text-align: right; 
  width: auto;
  max-width: 900px;
  height: auto;
  text-align:left;
  white-space:normal;
  padding-bottom: 5vh;
  letter-spacing: 1.1px;
}
.credits_wrap{
  margin-left: 5vw;
  margin-right: 5vw;
}

}


@media screen and (min-width:1024px) {
  .norm_br_a{
    display: none;
  }
  .norm_br_b{
    display: block;
  }

  .norm_br_c{
    display: none;
  }

  .norm_br_d{
    display: block;
  }


#adjust_font {
  font-size: 12px;  
  }

.credits_text{
  /* border: 3px solid rgb(144, 2, 97);  */
  max-width: 1024px;
}

.titlelogo{
  /* border: 3px solid rgb(1, 60, 10);  */
  width:55px;

}

}


</style>